import React from 'react';

import pagerduty from 'src/lib/api/pagerduty';

import GenericAsyncSelect from 'src/views/components/select/GenericAsyncSelect';

const incidents = async () => {
  const { incidents } = await pagerduty.getIncidents();
  return incidents.map(incident => ({
    id: incident.id,
    label: incident.summary,
    html_url: incident.html_url
  }));
};

const IncidentsSelect = ({ ...props }) => {
  return (
    <GenericAsyncSelect
      options={incidents}
      {...props}
    />
  );
};

export default IncidentsSelect;
